module.exports = __webpack_public_path__ + "images/payment-type.svg";